import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsComponent } from './news.component';
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {ArticleModule} from "@app/pages/news/article/article.module";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {NewsSortModule} from "@app/pages/news/sort/news-sort.module";
import {EditArticleModule} from "@app/pages/news/edit-article/edit-article.module";
import {FilterPipeModule} from "@app/pipes/filter/filter-pipe.module";
import {LogPipeModule} from "@app/pipes/log/log-pipe.module";



@NgModule({
  declarations: [NewsComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        ArticleModule,
        DragDropModule,
        NewsSortModule,
        EditArticleModule,
        FilterPipeModule,
        LogPipeModule
    ]
})
export class NewsModule { }
